import { RichTextInput } from 'ra-input-rich-text';
import {
  AutocompleteInput,
    BooleanInput,
    DateField,
    Edit,
    FormDataConsumer,
    NullableBooleanInput,
    ReferenceInput,
    required,
    RichTextField,
    SelectInput,
    SimpleForm,
    TextField,
    TextInput,
  } from 'react-admin';
  
  export const SettingsEdit = () => (
    <Edit>
      <SimpleForm>
        <RichTextInput source="web_notice" />
        <RichTextInput source="web_notice_fr" />
        <BooleanInput source="web_notice_active" label="Active" />
      </SimpleForm>
    </Edit>
  );
  